import { useTranslation } from 'react-i18next';

export const useTranslations = () => {
  const { t, i18n } = useTranslation();

  // Helper function to translate with fallback
  const translate = (key, options = {}) => {
    return t(key, options);
  };

  // Helper function to check if translation exists
  const hasTranslation = (key) => {
    return i18n.exists(key);
  };

  // Helper function to get current language
  const getCurrentLanguage = () => {
    return i18n.language;
  };

  // Helper function to get available languages
  const getAvailableLanguages = () => {
    return Object.keys(i18n.options.resources);
  };

  return {
    t: translate,
    hasTranslation,
    getCurrentLanguage,
    getAvailableLanguages,
    i18n
  };
}; 